export type FormField = {
  name: string
  type: string
  config: object
  required: boolean
}

export type IdNameModel = {
  id: string
  name: string
}

export type FormConfiguration = {
  _id: string | null
  name: string
  description: string | null
  fields: FormField[]
  enabled: boolean
  site_ids: string[] // Uses location_id
  terminal_ids: string[]
  sites: IdNameModel[]
  sectors: IdNameModel[]
  markets: IdNameModel[]
  terminals: IdNameModel[]
  supply_zones: IdNameModel[]
}

export type SupplyZoneHierarchy = {
  id: string
  name: string
  terminals: IdNameModel[]
}

export type SectorHierarchy = {
  id: string
  name: string
  sites: IdNameModel[]
}

export type MarketHierarchy = {
  id: string
  name: string
  sectors: SectorHierarchy[]
}

export type FormMetadata = {
  supply_zones: SupplyZoneHierarchy[]
  markets: MarketHierarchy[]
}

export type FormResponse = {
  name: string
  description: string | null
  order_number: number
  driver_name: string
  date: Date
  shift: string
  location_name: string | null
  address: string | null
  latitude: number | null
  longitude: number | null
  market: string
  sector: string | null
  supply_zone: string | null
  tractor: string | null
  trailer: string | null
  required: boolean
  response: FormFieldResponse[]
}

export enum FormFieldType {
  NUMBER = 'number',
  TEXT = 'text',
  SELECT = 'select',
  DATE = 'date',
  DATERANGE = 'daterange',
  RADIO = 'radio',
}

export type FormFieldResponse = {
  field_name: string
  field_type: FormFieldType
  value: any
  required: boolean
}

export type FormResponseOverviewReq = {
  start_date: Date
  end_date: Date
  market: string | null
}
